const apiGatewayConfig = {
  isEnabled: true,
  ignoredUrl: 'apixt.indmoney.com',
  ignoredUrls: [],
  replacementMap: {
    'us-stocks-ext.indmoney.com': {
      'us-stocks-ext.indmoney.com/auth': 'apixt-fz.indmoney.com/us-stocks-ext',
    },
    'us-stocks-ext.indiawealth.in': {
      'us-stocks-ext.indiawealth.in/auth':
        'apixt-fz.indmoney.com/us-stocks-ext',
    },
    'fd-ext.indmoney.com': {
      'fd-ext.indmoney.com': 'apixt-fz.indmoney.com/fd-ext',
    },
    'fd-ext.indiawealth.in': {
      'fd-ext.indiawealth.in': 'apixt-fz.indmoney.com/fd-ext',
    },
    'widget-prod.indmoney.com': {
      'widget-prod.indmoney.com': 'apixt-iw.indmoney.com/widget-prod',
    },
    'acc-aggregator.indmoney.com': {
      'acc-aggregator.indmoney.com': 'apixt-iw.indmoney.com/acc-aggregator',
    },
    'neo-ext.indmoney.com': {
      'neo-ext.indmoney.com/api': 'apixt-iw.indmoney.com/neo-ext',
    },
    'goal.indmoney.com': {
      'goal.indmoney.com/api': 'apixt-iw.indmoney.com/goal',
    },
    'mf-ext.indmoney.com': {
      'mf-ext.indmoney.com/api/public': 'apixt-iw.indmoney.com/mf-ext',
    },
    'global-search.indmoney.com': {
      'global-search.indmoney.com': 'apixt-iw.indmoney.com/global-search',
    },
    'octopus.indmoney.com': {
      'octopus.indmoney.com': 'apixt-iw.indmoney.com/octopus',
    },
    'indrewards.indmoney.com': {
      'indrewards.indmoney.com': 'apixt-iw.indmoney.com/indrewards',
    },
    'ind-federal.indiawealth.in': {
      'ind-federal.indiawealth.in': 'apixt-iw.indmoney.com/ind-federal',
    },
    'ind-federal.indmoney.com': {
      'ind-federal.indmoney.com': 'apixt-iw.indmoney.com/ind-federal',
    },
    'ind-investment.indmoney.com': {
      'ind-investment.indmoney.com': 'apixt-iw.indmoney.com/ind-investment',
      'ind-investment.indmoney.com/private/widget':
        'apixt-iw.indmoney.com/ind-investment-private',
    },
    'advisory-ext.indmoney.com': {
      'advisory-ext.indmoney.com': 'apixt-iw.indmoney.com/advisory-ext',
    },
    'mf-tracking-ext.indmoney.com': {
      'mf-tracking-ext.indmoney.com/public':
        'apixt-iw.indmoney.com/mf-tracking-ext',
    },
    'indcredx.indmoney.com': {
      'indcredx.indmoney.com/api': 'apixt-iw.indmoney.com/indcredx',
    },
    'vyapar-backoffice.indmoney.com': {
      'vyapar-backoffice.indmoney.com':
        'apixt-in.indmoney.com/vyapar-backoffice',
    },
    'indshield.indmoney.com': {
      'indshield.indmoney.com': 'apixt-iw.indmoney.com/indshield',
    },
    'payments.indiawealth.in': {
      'payments.indiawealth.in': 'apixt-iw.indmoney.com/payments',
    },
    'payments.indmoney.com': {
      'payments.indmoney.com': 'apixt-iw.indmoney.com/payments',
    },
    'vyapar.indmoney.com': {
      'vyapar.indmoney.com': 'apixt-in.indmoney.com/vyapar',
    },
    'vyapar-temp.indmoney.com': {
      'vyapar-temp.indmoney.com': 'apixt-in.indmoney.com/vyapar-temp',
    },
    'minisave.indmoney.com': {
      'minisave.indmoney.com': 'apixt-fz.indmoney.com/minisave',
    },
    'indian-stock-broker.indmoney.com': {
      'indian-stock-broker.indmoney.com':
        'apixt-in.indmoney.com/indian-stock-broker',
    },
    'indingress.indmoney.com': {
      'indingress.indmoney.com': 'apixt-iw.indmoney.com/ingress',
    },
    'ind-memory-ext.indmoney.com': {
      'ind-memory-ext.indmoney.com/public':
        'apixt-iw.indmoney.com/ind-memory-ext/public',
      'ind-memory-ext.indmoney.com/api':
        'apixt-iw.indmoney.com/ind-memory-ext/api',
    },
    'ind-cc.indmoney.com': {
      'ind-cc.indmoney.com': 'apixt.indmoney.com/ind-cc',
    },
    'widget.indiawealth.in': {
      'widget.indiawealth.in': 'apixt-iw.indmoney.com/widget-prod',
    },
    'acc-aggregator.indiawealth.in': {
      'acc-aggregator.indiawealth.in': 'apixt-iw.indmoney.com/acc-aggregator',
    },
    'neo-ext.indiawealth.in': {
      'neo-ext.indiawealth.in/api': 'apixt-iw.indmoney.com/neo-ext',
    },
    'goal.indiawealth.in': {
      'goal.indiawealth.in/api': 'apixt-iw.indmoney.com/goal',
    },
    'mf-ext.indiawealth.in': {
      'mf-ext.indiawealth.in/api/public': 'apixt-iw.indmoney.com/mf-ext',
    },
    'global-search.indiawealth.in': {
      'global-search.indiawealth.in': 'apixt-iw.indmoney.com/global-search',
    },
    'octopus.indiawealth.in': {
      'octopus.indiawealth.in': 'apixt-iw.indmoney.com/octopus',
    },
    'indrewards.indiawealth.in': {
      'indrewards.indiawealth.in': 'apixt-iw.indmoney.com/indrewards',
    },
    'ind-investment.indiawealth.in': {
      'ind-investment.indiawealth.in': 'apixt-iw.indmoney.com/ind-investment',
      'ind-investment.indiawealth.in/private/widget':
        'apixt-iw.indmoney.com/ind-investment-private',
    },
    'advisory-ext.indiawealth.in': {
      'advisory-ext.indiawealth.in': 'apixt-iw.indmoney.com/advisory-ext',
    },
    'mf-tracking-ext.indiawealth.in': {
      'mf-tracking-ext.indiawealth.in/public':
        'apixt-iw.indmoney.com/mf-tracking-ext',
    },
    'indcredx.indiawealth.in': {
      'indcredx.indiawealth.in/api': 'apixt-iw.indmoney.com/indcredx',
    },
    'vyapar-backoffice.indiawealth.in': {
      'vyapar-backoffice.indiawealth.in':
        'apixt-in.indmoney.com/vyapar-backoffice',
    },
    'insurance-ext.indiawealth.in': {
      'insurance-ext.indiawealth.in/external':
        'apixt-fz.indmoney.com/insurance-ext',
    },
    'insurance-ext.indmoney.com': {
      'insurance-ext.indmoney.com/external':
        'apixt-fz.indmoney.com/insurance-ext',
    },
    'indshield.indiawealth.in': {
      'indshield.indiawealth.in': 'apixt-iw.indmoney.com/indshield',
    },
    'vyapar.indiawealth.in': {
      'vyapar.indiawealth.in': 'apixt-in.indmoney.com/vyapar',
    },
    'minisave.indiawealth.in': {
      'minisave.indiawealth.in': 'apixt-fz.indmoney.com/minisave',
    },
    'indian-stock-broker.indiawealth.in': {
      'indian-stock-broker.indiawealth.in':
        'apixt-in.indmoney.com/indian-stock-broker',
    },
    'indingress.indiawealth.in': {
      'indingress.indiawealth.in': 'apixt-iw.indmoney.com/ingress',
    },
    'ind-memory-ext.indiawealth.in': {
      'ind-memory-ext.indiawealth.in/public':
        'apixt-iw.indmoney.com/ind-memory-ext/public',
      'ind-memory-ext.indiawealth.in/api':
        'apixt-iw.indmoney.com/ind-memory-ext/api',
    },
    'indiawealth.in': {
      'indiawealth.in': 'apixt-iw.indmoney.com/core',
    },
    'www.indiawealth.in': {
      'www.indiawealth.in': 'apixt-iw.indmoney.com/core',
    },
    'ind-cc.indiawealth.in': {
      'ind-cc.indiawealth.in': 'apixt.indmoney.com/ind-cc',
    },
    'core.indmoney.com': {
      'core.indmoney.com': 'apixt-iw.indmoney.com/core',
    },
    'indsta-cash.indiawealth.in': {
      'indsta-cash.indiawealth.in': 'apixt-iw.indmoney.com/indsta-cash',
    },
    'indsta-cash.indmoney.com': {
      'indsta-cash.indmoney.com': 'apixt-iw.indmoney.com/indsta-cash',
    },
    'flames.indmoney.com': {
      'flames.indmoney.com': 'apixt-iw.indmoney.com/flames',
    },
    'ind-learn.indiawealth.in': {
      'ind-learn.indiawealth.in': 'apixt-iw.indmoney.com/ind-learn',
    },
    'lvd.indmoney.com': {
      'lvd.indmoney.com': 'apixt-iw.indmoney.com/lvd',
    },
    'policycare.indmoney.com': {
      'policycare.indmoney.com': 'apixt-fz.indmoney.com/policycare',
    },
    'goals.indmoney.com': {
      'goals.indmoney.com': 'apixt-iw.indmoney.com/goals',
    },
    'credit-report.indmoney.com': {
      'credit-report.indmoney.com': 'apixt-fz.indmoney.com/credit-report',
    },
    'indgpt-ext.indmoney.com': {
      'indgpt-ext.indmoney.com': 'apixt-iw.indmoney.com/indgpt-ext',
    },
    'profilex-app.indmoney.com': {
      'profilex-app.indmoney.com': 'apixt-iw.indmoney.com/profilex-public',
    },
    'profilex.indmoney.com': {
      'profilex.indmoney.com': 'apixt-iw.indmoney.com/profilex',
    },
    'onboarding-ext.indiawealth.in': {
      'onboarding-ext.indiawealth.in': 'apixt-iw.indmoney.com/onboarding',
    },
    'hawkeye-ext.indmoney.com': {
      'hawkeye-ext.indmoney.com': 'apixt-in.indmoney.com/hawkeye-ext',
    },
    'two-sided.indiawealth.in': {
      'two-sided.indiawealth.in': 'apixt-iw.indmoney.com/two-sided',
    },
    'track-ext.indiawealth.in': {
      'track-ext.indiawealth.in': 'apixt-iw.indmoney.com/track',
    },
  },
}

export const getApiGatewayUrl = (url: string | URL) => {
  let apiUrl = url.toString()
  const urlWithoutHttps = apiUrl.split('https://')[1]
  if (urlWithoutHttps) {
    const baseUrl = urlWithoutHttps.split('/')[0]
    // check if config has matching base URL
    if (baseUrl && apiGatewayConfig.replacementMap[baseUrl]) {
      const replacementMap = apiGatewayConfig.replacementMap[baseUrl]
      Object.keys(replacementMap).forEach(urlSubstrToBeModified => {
        if (apiUrl.includes(urlSubstrToBeModified)) {
          const modifiedUrlSubstr = replacementMap[urlSubstrToBeModified]
          apiUrl = apiUrl.replace(urlSubstrToBeModified, modifiedUrlSubstr)
        }
      })
    }
  }
  return apiUrl
}
